module.exports = __webpack_public_path__ + "media/assets/images/favicon-8973249b7f75ca2bd8974f02fd561999.png";